import { createGlobalStyle } from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

export default createGlobalStyle`

  font-size: 20px;

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    background: #444;
  }

  body {
    -webkit-font-smoothing: antialiased;
  }

  border-style, input, button {
    /*  */
  }

  button {
    cursor: pointer;
  }
`;
